import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Badge,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFile,
  faVideo,
  faQuestionCircle,
  faCreditCard,
  faUsers,
  faFileContract,
  faWallet,
  faCalendarAlt,
  faChevronDown, 
  faArrowLeft,
  faHeadset,
  faPhone,
  faClock,
  faTicketAlt
} from '@fortawesome/free-solid-svg-icons';
import './FAQModal.css';

const FAQModal = ({ open, toggle }) => {
  const [view, setView] = useState('main');
  const [selectedFaq, setSelectedFaq] = useState('1');
  const [selectedSupportOption, setSelectedSupportOption] = useState(null);
  const [showTicketForm, setShowTicketForm] = useState(false);

  // Componente para el reproductor de video
  const VideoPlayer = ({ faq }) => {
    if (!faq) return null;
    
    return (
      <div className="video-player-container">
        <div className="video-player-header">
          <FontAwesomeIcon icon={faVideo} className="video-icon" />
          <div className="video-info">
            <h6 className="video-title">{faq.videoTitle}</h6>
            <Badge color="primary" pill className="video-badge">
              Tutorial en video
            </Badge>
          </div>
        </div>
        <div className="video-wrapper">
          <video 
            controls 
            className="custom-video-player"
            key={faq.videoSrc}
          >
            <source src={faq.videoSrc} type="video/mp4" />
            Tu navegador no soporta el elemento de video.
          </video>
        </div>
      </div>
    );
  };

  const faqs = [
    {
      id: '1',
      category: 'Documentos',
      icon: faFile,
      q: '¿Cómo enviar libros de venta?',
      videoSrc: "https://pub-27b15ae4d9ae4e9aba415401e66b8126.r2.dev/LIBROS_DE_VENTA.mp4",
      videoTitle: "Cómo enviar libros de venta",
      instructions: (
        <div className="content-section">
          <h6 className="section-subtitle">
            <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
            Pasos para enviar libros de venta
          </h6>
          <div className="steps-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Ingrese al portal</strong> con su usuario y contraseña
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Acceda al menú</strong> "Otras Acciones" y seleccione "Libros de Venta"
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Descargue la plantilla en Excel</strong> con el formato correcto
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">4</span>
              <div className="step-content">
                <strong>Complete los datos requeridos</strong> en la plantilla respetando el formato
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">5</span>
              <div className="step-content">
                <strong>Cargue el archivo</strong> en la sección Archivo de Carga
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">6</span>
              <div className="step-content">
                <strong>Verifique el resumen</strong> y confirme el envío
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: '2',
      category: 'Crédito',
      icon: faCreditCard,
      q: '¿Cómo solicitar una línea de crédito?',
      videoSrc: "https://pub-27b15ae4d9ae4e9aba415401e66b8126.r2.dev/SOLICITUD_DE_LINEA.mp4",
      videoTitle: "Cómo solicitar una línea de crédito",
      instructions: (
        <div className="content-section">
          <h6 className="section-subtitle">
            <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
            Pasos para solicitar una línea de crédito
          </h6>
          <div className="steps-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Ingrese al portal</strong> con su usuario y contraseña
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Acceda al menú</strong> "Mi crédito" y seleccione "Solicitud de Línea"
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Complete el formulario</strong> con la información solicitada
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">4</span>
              <div className="step-content">
                <strong>Adjunte los documentos requeridos</strong> en formato PDF
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">5</span>
              <div className="step-content">
                <strong>Revise la información ingresada</strong> y envíe la solicitud
              </div>
            </div>

            <div className="step-item">
              <span className="step-number">6</span>
              <div className="step-content">
                <strong>Espere la confirmación</strong> vía correo electrónico
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: '3',
      category: 'Prórrogas',
      icon: faCalendarAlt,
      q: '¿Cómo solicitar una prórroga?',
      videoSrc: "https://pub-27b15ae4d9ae4e9aba415401e66b8126.r2.dev/SOLICITUD_PRORROGA.mp4",
      videoTitle: "Cómo solicitar una prórroga",
      instructions: (
        <div className="content-section">
          <h6 className="section-subtitle">
            <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
            Pasos para solicitar una prórroga
          </h6>
          <div className="steps-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Ingrese a "Otras Acciones"</strong> y seleccione "Solicitud de Prórrogas"
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Descargue la plantilla</strong> y complétela con los datos solicitados
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Cargue la solicitud</strong> indicando el asunto, los comentarios adicionales y adjuntando el archivo
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">4</span>
              <div className="step-content">
                <strong>Confirme el envío</strong>
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">5</span>
              <div className="step-content">
                <strong>Revise el seguimiento de su solicitud</strong> en la sección "Comentarios", donde encontrará la conversación con nuestros analistas
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: '4',
      category: 'Usuarios',
      icon: faUsers,
      q: '¿Cómo registrarse como nuevo usuario?',
      videoSrc: "https://pub-27b15ae4d9ae4e9aba415401e66b8126.r2.dev/REGISTRO_DE_USUARIO.mp4",
      videoTitle: "Cómo registrarse como nuevo usuario",
      instructions: (
        <div className="content-section">
          <h6 className="section-subtitle">
            <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
            Registro de un nuevo usuario
          </h6>
          <div className="steps-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Revise el correo de bienvenida:</strong> al registrar su empresa recibirá un email para establecer su contraseña (revise la carpeta de spam)
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Establezca su contraseña</strong> desde el enlace del correo
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Ingrese al sistema</strong> con su usuario y contraseña
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">4</span>
              <div className="step-content">
                <strong>Acceda a "Usuarios"</strong> dentro del menú desplegable "Seguro de Crédito"
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">5</span>
              <div className="step-content">
                <strong>Cree un usuario</strong> completando los campos obligatorios y guardando
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">6</span>
              <div className="step-content">
                <strong>Gestione los usuarios:</strong> podrá activar, desactivar o editar cada registro creado
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: '5',
      category: 'Pólizas',
      icon: faFileContract,
      q: '¿Cómo consultar mi póliza?',
      videoSrc: "https://pub-27b15ae4d9ae4e9aba415401e66b8126.r2.dev/MI_POLIZA.mp4",
      videoTitle: "Cómo consultar mi póliza",
      instructions: (
        <div className="content-section">
          <h6 className="section-subtitle">
            <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
            Consulta de pólizas
          </h6>
          <div className="steps-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Haga clic en "Mi póliza"</strong>
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Filtre por vigencia</strong> si desea acotar la búsqueda
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Descargue pólizas o endosos</strong> desde la columna "Acciones"
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">4</span>
              <div className="step-content">
                <strong>Revise los detalles</strong> desplazándose hacia abajo en la página
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: '6',
      category: 'Cartera',
      icon: faWallet,
      q: '¿Cómo revisar mi cartera de créditos?',
      videoSrc: "https://pub-27b15ae4d9ae4e9aba415401e66b8126.r2.dev/MI_CARTERA.mp4",
      videoTitle: "Cómo revisar mi cartera de créditos",
      instructions: (
        <div className="content-section">
          <h6 className="section-subtitle">
            <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
            Revisión de tu cartera de créditos
          </h6>
          <div className="steps-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Ingrese a "Mi cartera"</strong> en el menú principal
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Visualice el dashboard</strong> con el estado de sus líneas: Aprobada, Rechazada, Pendiente, etc
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Gestione sus líneas:</strong> solicite aumento (lápiz), apelación (martillo) o desbloqueo (candado)
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">4</span>
              <div className="step-content">
                <strong>Descargue la información:</strong> "Mi cartera actual" (vigente en Excel) o "Mi cartera histórica" (todos los movimientos)
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const toggleAccordion = (faqId) => {
    setSelectedFaq(prev => (prev === faqId ? null : faqId));
  };

  const handleToggle = () => {
    setView('main');
    setSelectedFaq('1');
    setSelectedSupportOption(null);
    setShowTicketForm(false);
    toggle();
  };

  const handleViewChange = (newView) => {
    setView(newView);
    setShowTicketForm(false);
    if (newView === 'tutoriales') {
      setSelectedFaq('1');
    }
  };

  const handleSendTicket = () => {
    setShowTicketForm(true);
  };

  // Find the currently selected FAQ
  const currentFaq = faqs.find(faq => faq.id === selectedFaq);

  return (
    <Modal isOpen={open} toggle={handleToggle} size="xl" className="faq-modal" contentClassName="faq-modal-content">
      <ModalHeader toggle={handleToggle} className="modern-modal-header">
        <div className="header-content">
          {view !== 'main' && (
            <button 
              className="header-back-button"
              onClick={() => setView('main')}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}

          <FontAwesomeIcon icon={faQuestionCircle} className="header-icon" />
          <div>
            <h5 className="modal-title">Centro de ayuda y tutoriales</h5>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="modern-modal-body">
        {/* Vista Principal - Selector entre Tutoriales y Soporte */}
        {view === 'main' && (
          <div className="main-view">
            <div className="options-container">
              <div className="option-card" onClick={() => handleViewChange('tutoriales')}>
                <div className="option-icon">
                  <FontAwesomeIcon icon={faVideo} size="3x" />
                </div>
                <h5 className="option-title">Tutoriales</h5>
              </div>
              
              <div className="option-card" onClick={() => handleViewChange('soporte')}>
                <div className="option-icon">
                  <FontAwesomeIcon icon={faHeadset} size="3x" />
                </div>
                <h5 className="option-title">Soporte</h5>
              </div>
            </div>
          </div>
        )}

        {/* Vista de Tutoriales */}
        {view === 'tutoriales' && (
          <>
            <div className="faq-layout">
              {/* Columna izquierda - Video */}
              <div className="video-column">
                <VideoPlayer faq={currentFaq} />
              </div>

              {/* Columna derecha - Accordions */}
              <div className="accordion-column">
                <div className="accordion-header-section">
                  <h6 className="section-title">
                    <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
                    Selecciona un tema
                  </h6>
                </div>

                <div className="accordion-list">
                  {faqs.map((faq) => (
                    <div key={faq.id} className="accordion-item">
                      {/* Accordion Header */}
                      <div 
                        className={`accordion-header ${faq.id === selectedFaq ? 'active' : ''}`}
                        onClick={() => toggleAccordion(faq.id)}
                      >
                        <div className="accordion-header-content">
                          <FontAwesomeIcon icon={faq.icon} className="question-icon" />
                          <div className="question-info">
                            <Badge color="secondary" className="category-badge">
                              {faq.category}
                            </Badge>
                            <span className="question-text">{faq.q}</span>
                          </div>
                        </div>
                        <FontAwesomeIcon 
                          icon={faChevronDown} 
                          className={`chevron-icon ${faq.id === selectedFaq ? 'rotated' : ''}`}
                        />
                      </div>

                      {/* Accordion Content - Instructions */}
                      <div className={`accordion-content ${faq.id === selectedFaq ? 'active' : ''}`}>
                        <div className="accordion-body">
                          <div className="instructions-panel">
                            <div className="instructions-content">
                              {faq.instructions}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/* Vista de Soporte */}
        {view === 'soporte' && !showTicketForm && (
          <div className="soporte-view">
            <div className="soporte-options">
              <div 
                className={`soporte-card ${selectedSupportOption === 'garantia' ? 'selected' : ''}`}
                onClick={() => setSelectedSupportOption(selectedSupportOption === 'garantia' ? null : 'garantia')}
              >
                <h5 className="soporte-card-title">Garantía</h5>
                <p className="soporte-card-subtitle">¿Desea avisar o gestionar alguna acción de una línea de garantía?</p>
                {selectedSupportOption === 'garantia' && (
                  <div className="phone-display">
                    <FontAwesomeIcon icon={faPhone} className="phone-icon" />
                    <span className="phone-number">Alejandra Aguilar: +56 9 8792 7699</span>
                  </div>
                )}
              </div>

              <div 
                className={`soporte-card ${selectedSupportOption === 'credito' ? 'selected' : ''}`}
                onClick={() => setSelectedSupportOption(selectedSupportOption === 'credito' ? null : 'credito')}
              >
                <h5 className="soporte-card-title">Crédito</h5>
                <p className="soporte-card-subtitle">¿Desea avisar o gestionar alguna acción de una línea de crédito?</p>
                {selectedSupportOption === 'credito' && (
                  <div className="credito-options">
                    <div className="phone-display">
                      <FontAwesomeIcon icon={faPhone} className="phone-icon" />
                      <span className="phone-number">Sebastian Navarrete: +56 9 6308 2897</span>
                    </div>
                    <button 
                      className="send-ticket-button"
                      onClick={handleSendTicket}
                    >
                      <FontAwesomeIcon icon={faTicketAlt} className="button-icon" />
                      Ingresar Ticket de Soporte
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="support-schedule-info">
              <h6 className="schedule-title">
                <FontAwesomeIcon icon={faClock} className="mr-2" />
                Horario de Soporte en Línea
              </h6>
              <p className="schedule-text">
                Nuestro equipo de soporte está disponible de <strong>Lunes a Jueves entre las 09:00 y las 19:00 horas</strong>, 
                y los <strong>viernes entre las 09:00 y las 16:00 horas</strong>.
              </p>
              <p className="schedule-text">
                Fuera de este horario, le invitamos a ingresar un <strong>ticket de atención</strong>, 
                el cual será gestionado y respondido dentro de las <strong>24 horas hábiles siguientes</strong>.
              </p>
            </div>
          </div>
        )}

        {/* Ticket Form - Full screen when active */}
        {showTicketForm && (
          <div className="ticket-form-fullscreen">
            <div className="support-form-container">
              <iframe 
                sandbox="allow-scripts allow-popups allow-forms allow-same-origin" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }}
                src="https://forms.helpdesk.com?licenseID=1291909759&contactFormID=b47d254c-2134-450e-a720-eb6181849b7e"
              >
                Your browser does not allow embedded content.
              </iframe>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default FAQModal;